<template>
  <div class="car-search"
       style="height: calc(100vh - 100px);padding:0 10px">
    <div style="height: calc(6vh)">
      <div class="search-title">车辆研判</div>
    </div>
    <div style="height: calc(30vh)">
      <el-form ref="ruleForm"
               :model="formListData"
               :rules="rules">
        <div style="display: flex">
          <div style="flex: 1; height: calc(27vh)">
            <el-form-item label="车牌号码："
                          prop="plateCode"
                          style="width: 80%; margin: 8px auto">
              <el-input style="width: 65%"
                        v-model="formListData.plateCode"
                        placeholder="请输入车牌号"></el-input>
            </el-form-item>
            <el-form-item label="开始时间："
                          prop="startTime"
                          style="width: 80%; margin: 8px auto">
              <el-date-picker v-model="formListData.startTime"
                              style="width: 65%"
                              type="datetime"
                              placeholder="开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间："
                          prop="endTime"
                          style="width: 80%; margin: 8px auto">
              <el-date-picker v-model="formListData.endTime"
                              style="width: 65%"
                              type="datetime"
                              placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="区域点位："
                          prop="area"
                          style="width: 80%; margin: 8px auto">
              <el-input style="width: 65%"
                        :readonly="true"
                        @click.native="showTree"
                        v-model="formListData.areaName"
                        placeholder="请选择区域点位"></el-input>
            </el-form-item>
            <div style="text-align: center; margin-top: 15px">
              <el-button size="mini"
                         type="primary"
                         @click="submitClick('ruleForm')">查询</el-button>
              <el-button size="mini"
                         type="info"
                         @click="resetFrom">重置</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="search-result flex-valign"
         id="mainList">
      <div style="margin: 0 0 8px 15px">查询结果</div>
      <div v-if="searchDataList.length > 0"
           style="height: calc(50vh); overflow: auto">
        <div v-for="(item, index) in searchDataList"
             class="searchList"
             :key="index">
          <div style="flex: 1">
            <img :src="imgPath(item)"
                 class="image"
                 onerror="this.src='/images/theme/newDark/default.png'"
                 style="width: 90px; height: 90px" />
          </div>
          <div style="flex: 3; position: relative">
            <div style="margin: 5px; color: #fff; padding-left: 5px">
              <span style="color: #95a6c1">车主： </span>
              <span>{{ item.ownerName ? item.ownerName : "未知车辆" }}</span>
            </div>
            <div style="margin: 5px; color: #fff; padding-left: 5px">
              <span style="color: #95a6c1">车牌： </span>
              <span>{{ item.plateCode }}</span>
            </div>
            <div style="margin: 5px; color: #fff; padding-left: 5px">
              <span style="color: #95a6c1">类型： </span>
              <span>{{ item.vehicleTypeName }}</span>
            </div>
            <div style="margin: 5px; color: #fff; padding-left: 5px">
              <span style="color: #95a6c1">颜色： </span>
              <span>{{ item.vehicleColorName }}</span>
            </div>
            <div style="text-align:right">
              <el-button type="primary"
                         size="small"
                         @click="carDetails(item)">查询车辆轨迹</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else
           style="text-align: center">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { Dic, Bus, Dates } from "$utils";
// import appCamersGroup from '@components/app-camera-group'
// import trackDetail from '@src/components/business/app-track-detail/track-detail.vue'
import { api } from "../api";
export default {
  components: {
    // appCamersGroup,
    // trackDetail
  },
  data () {
    return {
      changeAllChecked: true,
      allChecked: true,
      getJson: false,
      dateTime: "",
      dateTimeFlag: false,
      copyCheckboxGroupListIndex: 0,
      copyCheckboxGroupList: [],
      changeGroup: "",
      changeGroupIndex: 0,
      checkboxGroupList: [],
      moreList: [],
      carDetailsList: {},
      main: true,
      trackData: {},
      searchDataList: [],
      formListData: {
        plateCode: this.$route.params.plateCode
          ? this.$route.params.plateCode
          : "",
        area: [],
        areaName: "",
        startTime: Dates.parse(
          Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000)
        ),
        endTime: Dates.parse(Dates.format(new Date())),
      },
      showTreeList: false,
      fileList: [], // 上传图片数组
      treeData: [],
      imgFileList: [], // 保存名单中上传图片数组
      rules: {
        area: [{ required: true, message: "请选择区域" }],
        plateCode: [{ required: true, message: "请输入车牌号" }],
        startTime: [{ required: true, message: "选择时间" }],
        endTime: [{ required: true, message: "选择时间" }],
      },
      visibleRight: true,
    };
  },
  watch: {
    imgFileList: {
      handler (newValue, oldValue) {
        this.formData.fileList = newValue;
      },
      deep: true,
    },
    fileList: {
      handler (newValue, oldValue) {
        this.formData.fileList = newValue;
      },
      deep: true,
    },
    dateTime: {
      handler (newValue, oldValue) {
        this.dateTimeFlag = true;
      },
      deep: true,
    },
    changeGroup: {
      handler (newValue, oldValue) {
        if (oldValue) {
          this.getJson = true;
          let byName = newValue + this.changeGroupIndex;
          $("input[name='" + byName + "'").prop("checked", true);
        }
      },
      deep: true,
    },
    checkboxGroupList: {
      handler (newValue, oldValue) {
        console.log("newValue111", newValue);
        // 去勾选所有复选框
        $("input[type=checkbox]").prop("checked", false);
        this.changeAllChecked = true;
        this.copyCheckboxGroupList = JSON.parse(
          JSON.stringify(newValue.trailList)
        );
      },
      deep: true,
    },
  },
  beforeDestroy () {
    this.$map.hideMap2D();
    this.$map.clear();
  },
  mounted () {
    this.$map.showMap2D(this.initPage);
    this.$map.addClickEvent((e) => {
      console.log("e", e);
      this.showTrack = true;
      this.trackData = e;
      this.$refs.trackDetail.isTrackShow = true;
    });
    this.getAreaByAccount()
  },
  methods: {
    callback (loading) {
      loading.close();
    },
    validImg (file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = [
        "jpg",
        "png",
        "jpeg",
        "jpe",
        "dib",
        "bmp",
        "JPG",
        "PNG",
        "JPEG",
        "JPE",
        "DIB",
        "BMP",
      ];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);

      if (!isJPG) {
        this.$message.error(this.$t("personMg.message.formatWarn"));
        return false;
      }
      const Size = 1024 * 1024 * 1;
      if (file.size > Size) {
        this.$message.error(this.$t("personMg.message.sizeWarn"));
        return false;
      }
      return true;
    },
    // 删除图片
    removeFile (file, fileList) {
      if (this.formState === 2) {
        if (file.status === "update") {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url;
          });
          this.fileList.splice(index, 1);
        }
      }
      this.imgFileList = fileList;
    },
    getAreaByAccount () {
      //获取默认区域树结构
      this.$fetch('/cms/area/queryAreaDevGroupListByAccountNumber.json',).then((res) => {
        if (res && res.success) {
          const areaName = []
          let areaDevGroupList = new Array()
          areaDevGroupList = [...res.returnObj]
          areaDevGroupList.forEach((val) => {
            this.formListData.area.push(val.areaDevGroupCode)
            areaName.push(val.areaDevGroupName)
          })
          this.formListData.areaName = areaName.join(',');
        } else {
          this.$message.error("获取数据失败,请稍后再试")
        }
      });
    },
    showTree () {
      // this.$parent.showTreeList = true;
      // this.$emit('searchArea');
      this.$parent.$refs['areaTree'].openDialogDefaultChecked(this.formListData.area)
    },
    submitClick (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let days =
            (Date.parse(this.formListData.endTime) -
              Date.parse(this.formListData.startTime)) /
            86400000;
          console.log("days", days);
          if (days <= 0) {
            this.$message.warning("结束时间必须大于开始时间!");
            return false;
          }
          // 移除地图点位
          this.$map.MapInstance2D.clearPoint();
          // 移除地图轨迹
          this.$map.MapInstance2D.removeTrajectory();
          let params = {};
          params.area = this.formListData.area;
          params.plateCode = this.formListData.plateCode;
          params.startTime = this.formListData.startTime;
          params.endTime = this.formListData.endTime;
          // params.startTime = this.formListData.startTime
          //   ? Dates.dayjs(Number(this.formListData.startTime)).format('YYYY-MM-DDHH:mm:ss')
          //   : ''; //'开始时间'
          // params.endTime = this.formListData.endTime
          //   ? Dates.dayjs(Number(this.formListData.endTime)).format('YYYY-MM-DDHH:mm:ss')
          //   : ''; //'结束时间';
          const loading = this.$loading({
            target: document.querySelector("#mainList"),
            lock: true,
            text: "请求中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$fetch(api.searchVehicleTrail, params).then((res) => {
            if (res.success) {
              console.log("res", res);
              this.searchDataList = res.returnObj;
              loading.close();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    imgPath (item) {
      return item ? Bus.imgPath(item.fileCode) : "";
    },
    carDetails (item) {
      this.changeGroup = item.dateList[0].date;
      this.moreList = [];
      item.dateList.map((val, index) => {
        this.moreList.push({
          length: val.trailList.length,
          flg: 4,
        });
        this.$set(val, "isPeopleShow", false);
      });
      this.carDetailsList = item;
      // this.carDetailsList.dateList[0].isPeopleShow = true;
      this.$parent.main = false;
      this.$emit("carData", {
        moreList: this.moreList,
        carDetailsList: item,
      });
      // this.$nextTick(() => {
      //   this.getTrajectory(item.dateList[0], '0')
      // })
    },
    back () {
      this.$parent.main = true;
      this.carDetailsList = [];
      this.$map.MapInstance2D.clear();
    },
    getTrajectory (item, id) {
      let domId = "trajectoryId" + id;
      let allBorder = document.getElementsByClassName("trajectoryList");
      let changeBorder = document.getElementsByClassName(domId)[0];
      for (let i = 0; i < allBorder.length; i++) {
        allBorder[i].style.background = "#121722";
      }
      changeBorder.style.background = "#080B10";
      this.checkboxGroupList = item;
      // 移除地图点位
      this.$map.MapInstance2D.clearPoint();
      // 移除地图轨迹
      this.$map.MapInstance2D.removeTrajectory();
      // 设置地图点位
      let setPoint = [];
      let addPoint = [];
      this.$nextTick(() => {
        if (!this.allChecked && !this.changeAllChecked) {
          return false;
        }
        let pointList =
          this.getJson || this.copyCheckboxGroupList.length == 0
            ? item.trailList
            : this.copyCheckboxGroupList;
        pointList.map((val, index) => {
          setPoint.push({
            point: (function () {
              let ary = [];
              ary.push(val.longitude);
              ary.push(val.latitude);
              ary.push(val.rimageUrl);
              ary.push(val);
              return ary;
            })(val),
          });
          addPoint.push({
            id: index,
            longitude: val.longitude,
            latitude: val.latitude,
            src: val.rimageUrl,
            scale: 0.1,
            height: 0,
          });
        });
        console.log("setPoint", setPoint);
        if (setPoint.length >= 2) {
          this.$map.MapInstance2D.drawTrajectory(setPoint);
          console.log("setPoint[0].point", setPoint[1].point);
        } else {
          console.log("addPoint", addPoint);
          this.$map.MapInstance2D.addMarket(addPoint, addPoint[0].src);
        }
      });
    },
    resetFrom () {
      this.searchDataList = [];
      this.formListData.plateCode = "";
      this.formListData.startTime = Dates.parse(
        Dates.format(new Date().getTime() - 24 * 60 * 60 * 1000)
      );
      this.formListData.endTime = Dates.parse(Dates.format(new Date()));
      this.formListData.areaName = '';
      this.$refs["ruleForm"].resetFields();
      this.clearTree();
      this.$map.MapInstance2D.clear();
    },
    handleVisible () {
      if (this.visibleRight) {
        this.visibleRight = false;
      } else {
        this.visibleRight = true;
      }
    },
    initPage () {
      console.log("执行初始化地图");
    },
    clearTree () {
      // this.$parent.$refs["areaTree"].resetTreeData();
    },
    getMoreList (index) {
      this.moreList[index]["flg"] += 4;
    },
    TrackImgShow (index) {
      let isPeopleShow = this.carDetailsList.dateList[index].isPeopleShow;
      this.carDetailsList.dateList.map((val) => {
        val.isPeopleShow = false;
      });
      this.carDetailsList.dateList[index].isPeopleShow = !isPeopleShow;
      this.moreList[index]["flg"] = 4;
    },
  },
};
</script>
<style lang="scss">
@import "../style/carSearch.scss";
.car-search {
  .search-result {
    flex: 1 1 auto;
    margin-top: 15px;
  }
  .el-form {
    @include set_theme_color(background-color, dialog-main-bg-color);
  }
  .contraction-bar {
    position: relative;
    overflow: hidden;
    width: 100%;
    .vehicle-to {
      background-color: #1a1f2b;
      opacity: 0.8;
      position: absolute;
      right: 0;
      z-index: 2;
      &.expand {
        width: 350px;
      }
      &.collspand {
        display: none;
      }
    }
  }
  .arrow-left-span {
    width: 16px;
    background: rgba(26, 31, 43, 0.8);
    position: absolute;
    z-index: 2;
    height: 64px;
    // right: calc(26vw);
    top: calc(50% - 32px);
    border-bottom-left-radius: 16px;
    border-top-left-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &.expand {
      right: calc(26vw);
    }
    &.collspand {
      right: 0;
    }
  }
  .search-title {
    padding-left: 10px;
    @include set_theme_color(color, font-default-color);
  }
  .el-dialog {
    width: 25%;
  }
}
</style>